<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>新闻资讯</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-card class="box-card" style="margin-bottom: 20px;">
			<el-form :inline="true" class="user-search" :model="formInline">
				<!-- <el-form-item label="奖品名称：">
					<el-input size="small" placeholder="请输入奖品名称" v-model="formInline.appName" clearable></el-input>
				</el-form-item>
				<el-form-item label="奖品等级：">
					<el-select v-model="formInline.goodsLevel" placeholder="选择奖品等级" style="width: 150px;" clearable>
						<el-option :label="item" :value="item" v-for="item in 10" :key="item"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label="资讯类别：">
					<el-select v-model="formInline.classifyId" placeholder="选择资讯类别" style="width: 150px;" clearable>
						<el-option :label="item.name" :value="item.status" v-for="(item,index) in rankType"
							:key="index"></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="选定时间：">
					<datatime v-model="formInline.choiceTime" catename="choiceTime"></datatime>
				</el-form-item> -->
				<el-form-item>
					<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="danger" icon="el-icon-plus" @click="handleadd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column type="index" width="50" align="center"> </el-table-column>
			<el-table-column prop="title" label="资讯标题" align="center"> </el-table-column>
			<el-table-column prop="lastVersion" label="图片" align="center">
				<template slot-scope="scope">
					<el-image style="width: 60px;height: 60px;" :src="scope.row.coverImg"
						:preview-src-list="[scope.row.coverImg]">
					</el-image>
				</template>
			</el-table-column>
			<el-table-column prop="lastVersion" label="资讯类型" align="center">
				<template slot-scope="scope">
					{{getClassify(scope.row.classifyId)}}
				</template>
			</el-table-column>
			<el-table-column prop="lastVersion" label="发表时间" align="center">
				<template slot-scope="scope">
					{{web.formatTime(scope.row.creatTime,'Y-M-D h:m')}}
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleedit(scope.row)">
						编辑
					</el-button>
					<el-button size="mini" @click="handledelete(scope.row)">
						删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>
		<!-- 弹框 设代理和设置会员-->
		<el-dialog :close-on-click-modal="false" title="设置" :visible.sync="dialogVisible" width="1000px">
			<el-form label-width="120px">
				<el-form-item label="标题:">
					<el-input v-model="editForm.title" style="width: 600px;"></el-input>
				</el-form-item>
				<el-form-item label="简介:">
					<el-input type="textarea" resize="none" :autosize="{ minRows: 2}" v-model="editForm.introduction"></el-input>
				</el-form-item>
				<el-form-item label="资讯类别:">
					<el-select v-model="editForm.classifyId" placeholder="资讯类别" style="width: 120px;">
						<el-option :label="item.name" :value="item.status" v-for="(item,index) in rankType"
							:key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="图片:">
					<uploadone :url="editForm.coverImg" cateName="coverImg" @click="uploadone"></uploadone>
				</el-form-item>
				<el-form-item label="内容:">
				</el-form-item>
				<!-- <quill-edit @content="getContent" :width="800" :height="800" :des="editForm.content"></quill-edit> -->
				<quill-editor ref="text" v-model="editForm.content" class="myQuillEditor" :options="editorOption" />
			</el-form>
			<span slot="footer" class="dialog-footer" style="display: flex;justify-content: content;">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitedit">提交</el-button>

			</span>
		</el-dialog>


	</div>
</template>

<script>
	import {
		delNewsById,
		addAmendNews,
		getAllNews
	} from '../../api/basisMG.js'
	// import quillEdit from '../../components/quillEdit'
	// import quillEdit from 'vue-quill-editor'
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import uploadone from '@/components/uploadone'
	// import uploadwgt from '@/components/uploadwgt'
	// 导出模块
	export default {
		components: {
			// uploadwgt,
			uploadone,
			// quillEdit
		},

		// 模块数据
		data() {
			//数据  
			return {
				editbj:{},
				editorOption: {} ,
				decernerVisible:false,
				rankType: [{
						name: '最新资讯',
						status: 1
					},
					{
						name: '专业评测',
						status: 2
					},
					{
						name: '市场行情',
						status: 3
					},
					{
						name: '活动报道',
						status: 4
					}
				],
				goodsImg: '',
				loading: true,
				visible: false,
				listData: [],
				dialogVisible: false,
				formInline: {
					start: 0,
					length: 10
				},
				editForm: {
					content:''
				},
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 10,
					total: 10,
					start: 0,
					length: 10
				},
			}
		},


		watch: {},

		methods: {
			getClassify(val){
				if(val == 1){
					return '最新资讯'
				}
				if(val == 2){
					return '专业评测'
				}
				if(val == 3){
					return '市场行情'
				}
				if(val == 4){
					return '活动报道'
				}
			},
			getContent(content) {
				this.editForm.content = content
			},
			uploadone(data) {
				this.editForm.coverImg = data
			},
			handleadd() {
				this.dialogVisible = true
				this.editForm = {}

			},
			handleedit(row) {
				this.dialogVisible = true
				this.editForm = Object.assign({}, row)
				console.log(row.content)
			},
			handledelete(row) {
				this.$confirm('确认删除吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delNewsById({
						id: row.id
					}).then(res => {
						if (res.code == '200') {
							this.$message({
								message: '删除成功',
								type: 'success'
							})
							this.getdata()
						}

					})
				})

			},
			submitedit() {
				let param = this.editForm
				// param.upgradeId = this.editForm.id
				this.$confirm('确认提交吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					addAmendNews(param).then(res => {
						console.log(res)
						if (res.code == '200') {
							this.$message({
								message: '提交成功',
								type: 'success'
							})
							this.dialogVisible = false
							this.getdata()
						}

					})

				})

			},
			getdata() {
				getAllNews(this.formInline).then(res => {
					this.saveParams(this.$route.path,this.formInline)
					if (res.code == 200) {
						this.listData = res.data.content
						this.loading = false
						this.pageparm.total = res.data.totalElements
					}
				})
			},
			// 分页插件事件
			callFather(parm) {
				this.pageparm.currentPage = parm.currentPage
				this.pageparm.pageSize = parm.pageSize
				this.pageparm.start = parm.currentPage - 1
				this.pageparm.length = parm.pageSize
				this.formInline.start = parm.currentPage - 1
				this.formInline.length = parm.pageSize
				this.getdata(this.formInline)
			},
		},
		// 创建前状态(里面是操作)
		beforeCreate() {},
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			this.getdata()
		},
		// 挂载前状态(里面是操作)
		beforeMount() {},
		// 挂载结束状态(里面是操作)
		mounted() {},
		// 更新前状态(里面是操作)
		beforeUpdate() {},
		// 更新完成状态(里面是操作)
		updated() {},
		// 销毁前状态(里面是操作)
		beforeDestroy() {},
		// 销毁完成状态(里面是操作)
		destroyed() {}
	};
</script>

<style scoped>

</style>
